import React, { useState, useRef, useEffect } from "react";
import { getDriverLastLocation } from "../../Services/Driver.service";
import "mapbox-gl/dist/mapbox-gl.css";
/* eslint import/no-webpack-loader-syntax: off */
import mapboxgl from "!mapbox-gl";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESSTOKEN;

const MapBox = ({ driverObj, Large, cityData }) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [zoom, setZoom] = useState(9);
  useEffect(() => {
    if (!Large) return;
    console.log(driverObj, "driverObj");
    let obj = {
      driverId: driverObj.id,
      carNo: driverObj.mainCabNo,
    };
    getDriverLastLocation(obj).then((result) => {
      if (result.data) {
        if (result.data?.lat) {
          console.log(result.data, "mapdatatatata");
          const latLng = [result.data.lng, result.data.lat];
          new mapboxgl.Marker({ color: "blue" })
            .setLngLat(latLng)
            .addTo(map.current);

          map.current.setCenter(latLng);
        } else if (result.data.length > 1) {
          const route = result.data.map((element) => {
            return [element.lng, element.lat];
          });
          const geojson = {
            type: "Feature",
            properties: {},
            geometry: {
              type: "LineString",
              coordinates: route,
            },
          };
          // if the route already exists on the map, we'll reset it using setData
          if (map.current.getSource("route")) {
            map.current.getSource("route").setData(geojson);
          }
          // otherwise, we'll make a new request
          else {
            map.current.addLayer({
              id: "route",
              type: "line",
              source: {
                type: "geojson",
                data: geojson,
              },
              layout: {
                "line-join": "round",
                "line-cap": "round",
              },
              paint: {
                "line-color": "#3887be",
                "line-width": 5,
                "line-opacity": 0.75,
              },
            });
          }
        }
      }
    });
  }, [Large]);

  useEffect(() => {
    if (!Large) return;
    if (map.current) return; // initialize map only once
    // const driverCity=driverObj.serviceCityId;
    // console.log(driverCity,'driverCity');
    // console.log(cityData);
    // const cityObj=cityData.find(element=>element.id==driverCity);
    // console.log(cityObj,'cityObj');
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      // center: [cityObj.lng, cityObj.lat],
      zoom: zoom,
    });
  }, [Large]);
  return <div ref={mapContainer} className="map-container" />;
};

export default MapBox;
